<template>
  <v-tab-item
    class="child-tab-item"
    v-intersect="onIntersect"
  >
    <List head class="py-4" :head-left-title="headLeftTitle" :head-center-title="headCenterTitle" :head-right-title="headRightTitle" :list="list[skip]" :loading="loading">
    </List>
    <div class='mb-4 pagination-wrapper'
      v-if="pagination && showPagination">
      <v-pagination
        class="pagination align-self-center  align-self-md-end mr-2"
        :value="item.title == '企业公告' ? skip : skip+1"
        :length="paginationLength"
        :total-visible="7"
        color="primary"
        @input="input"
      ></v-pagination>
      <span>共{{paginationLength}}页</span>
      <span>跳转到</span>
      <v-text-field
        class="page-input"
        v-model="pageNum"
        dense
        outlined
      ></v-text-field>
      <v-btn class="submit" color="primary" width="60" @click="submit">确认</v-btn>
    </div>
  </v-tab-item>
</template>

<script>
// import { mapMutations } from 'vuex'
import List from '@/components/UI/List'
import API from '@/service'
export default {
  name: 'TabItem',
  components: {
    List
  },
  props: {
    item: Object,
    load: {
      type: Number
    },
    pagination: {
      type: Boolean,
      default: false
    },
    headLeftTitle: {
      type: String
    },
    headCenterTitle: {
      type: String
    },
    headRightTitle: {
      type: String
    }
  },
  data: () => {
    return {
      loaded: false,
      skip: 1,
      limit: 10,
      list: [],
      loading: true,
      paginationLength: 0,
      showPagination: false,
      query: null,
      pageNum: ''
    }
  },
  methods: {
    // ...mapMutations({
    //   setAppLoading: 'app/appLoading'
    // }),
    onIntersect (entries) {
      if (entries[0].isIntersecting && !this.loaded) {
        this.getData().then(() => {
          this.loaded = true
        })
      }
    },
    async getData () {
      try {
        // this.setAppLoading(true)
        this.loading = true
        let res
        const tenantid = this.item.tenantid
        const skip = this.skip
        const limit = this.limit
        const status = this.item.status
        const supEnterpriseIds = this.item.supEnterpriseIds
        const bidType = this.item.bidType
        if (this.item.title === '企业公告') {
          if (this.query) {
            res = await API.getEntNotice({ ...this.query, tenantid, skip, limit })
          } else {
            res = await API.getEntNotice({ tenantid, skip, limit })
          }
          res = res.data.data
          res.result = res.results
        } else {
          if (this.query) {
            res = await API.getLogisticsData({ ...this.query, status, skip, limit, supEnterpriseIds, bidType })
          } else {
            res = await API.getLogisticsData({ status, skip, limit, supEnterpriseIds, bidType })
          }
          res = res[0]
        }
        const { totalCount, totalPage, result } = res
        if (totalCount > this.limit) {
          this.showPagination = true
          this.paginationLength = totalPage
        }
        if (result.length > 0) {
          this.$set(this.list, skip, result.map(item => {
            if (this.item.title === '企业公告') {
              item.messageTitle = item.title
              item.publishTime = item.publishtime
              // item.purOrgName = '福州市城投建筑有限公司'
              item.purOrgName = ''
              item.messageTypeShow = '1'
            }
            const { id, messageTitle, publishTime, purOrgName, msgId, srcEnterpriseId, messageTypeShow, deadline, detailUrl } = item
            return {
              id,
              title: messageTitle,
              date: deadline !== undefined ? new Date(deadline.replace(/-/g, '/')) : new Date(publishTime.replace(/-/g, '/')),
              company: purOrgName,
              msgId: msgId,
              srcEnterpriseId: srcEnterpriseId,
              messageTypeShow: messageTypeShow,
              detailUrl: detailUrl
            }
          }))
        } else {
          this.$set(this.list, skip, [])
        }
        // console.log(res)
      } catch (error) {
        console.log(error)
      }
      this.loading = false
      // this.setAppLoading(false)
    },
    async submit () {
      this.skip = this.item.title === '企业公告' ? this.pageNum : this.pageNum - 1
      await this.getData()
    },
    async input (page) {
      this.skip = this.item.title === '企业公告' ? page : page - 1
      await this.getData()
    }
  },
  mounted () {
    this.skip = this.item.title === '企业公告' ? 1 : 0
    this.$gon('searchFilterSubmit', (data) => {
      this.query = data
      this.skip = this.item.title === '企业公告' ? 1 : 0
      this.paginationLength = 0
      this.getData()
    })
  },
  destroyed () {
    this.query = null
    this.$goff('searchFilterSubmit', () => {
      console.log('off')
    })
  }
}
</script>

<style lang="scss" scoped>
.child-tab-item {
  position: relative;
}
.pagination {
  display: inline-block;
  & + span {
    margin-right: 20px;
    & + span {
      margin-right: 10px;
    }
  }
}
.page-input {
  width: 50px;
  max-width: 50px!important;
  display: inline-block;
  margin-right: 15px;
}
.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  .submit {
    height: 28px;
  }
}
</style>
